import React from 'react';

import { CX_DISCOUNT_CODE_PREFIXES } from '../../pages/constants';
import { Customer } from '../../pages/types';
import {
  computeCustomerSpend,
  formatDateTime,
  getFulfilledOrderCount,
  getReplacedOrderCount,
  getCxCodeCount,
  getWinbackDiscountEligiblility,
  getFreeExtraMealBagEligiblility,
} from '../../utils';
import { InfoTooltip } from '../Tooltip';

export const CustomerStats = ({ customer }: { customer: Customer }) => {
  const optedIntoOrderReminders = customer.contact_preference_order === 'NONE' ? 'No' : 'Yes';

  return (
    <div className="flex-col">
      <h2 className="mb-1 flex items-center">
        <b className="inline-block">Customer Stats</b>
      </h2>
      <div className="bg-white border rounded-lg p-4 shadow-md h-[260px] overflow-y-scroll">
        <div className="mb-2">
          <strong>Customer since:</strong> {formatDateTime(customer.created)}
        </div>
        <div className="mb-2">
          <strong>Total lifetime spend amount:</strong> ${computeCustomerSpend(customer.orders)}{' '}
          {customer.default_currency}
        </div>
        <div className="mb-2">
          <strong>Number of fulfilled orders:</strong> {getFulfilledOrderCount(customer.orders)}
        </div>
        <div className="mb-2">
          <strong>Number of replaced orders:</strong> {getReplacedOrderCount(customer.orders)}
        </div>
        <div className="mb-2 flex items-center">
          <strong>Number of orders discounted by CX:</strong>{' '}
          <div className="flex items-center ml-1">
            <span>{getCxCodeCount(customer.orders)}</span>
            <div className="ml-1">
              <InfoTooltip
                text={`Sum of discounted orders with codes starting with ${CX_DISCOUNT_CODE_PREFIXES.join(
                  ', '
                )}`}
              />
            </div>
          </div>
        </div>
        <div className="mb-2">
          <strong>Winback discount code eligible: </strong>{' '}
          {getWinbackDiscountEligiblility(customer.orders)}
        </div>
        <div className="mb-2">
          <strong>Eligible for Free Extra Meal Bag: </strong>{' '}
          {getFreeExtraMealBagEligiblility(customer.orders)}
        </div>
        <div className="mb-2">
          <strong>Opted into Order Reminders: </strong> {optedIntoOrderReminders}
        </div>
      </div>
    </div>
  );
};
